/**
 * 数美防刷
 */ 
let SM = Object.assign({
    init() {
        const hostname = location.hostname;
        let apiHost = 'fp.fengkongcloud.com';
        
        if (hostname == 'm.upliveapps.com') {
            apiHost = 'fp-xjp.fengkongcloud.com';
        }
        
        (function() { 
                window._smConf = {
                    organization: '3kHDvmQMHMyhMkWHki4D', //需要修改为业务 organization
                    staticHost: 'static.fengkongcloud.com',
                    apiHost 
                };
                var sm = document.createElement("script");
                sm.src = ('https:' === document.location.protocol ? 'https:' : 'http:') + '//' + _smConf.staticHost + '/fpv2.js';
                var s = document.getElementsByTagName("script")[0];
                sm.onload = ()=>{
                    $.channel.emit('smsdkLoaded');
                };
                sm.onerror = ()=>{
                    $.channel.emit('smsdkLoadedError');
                }
                s.parentNode.insertBefore(sm, s); 
            }
        )();
    }
}, Uplib.Events);

SM.init();


// WEBPACK FOOTER //
// ./js/component/openjs/deps/SM/index.js